// ** React Imports
import { RouterOutlet } from 'react-router-outlet'

// ** Core Layout Import
// !Do not remove the Layout import
import Layout from '@core/layouts/HorizontalLayout'

// ** Menu Items Array
import navigation from 'navigation/horizontal'

const HorizontalLayout = props => {
  // const [menuData, setMenuData] = useState([])

  // ** For ServerSide navigation
  // useEffect(() => {
  //   axios.get(URL).then(response => setMenuData(response.data))
  // }, [])

  return (
    <Layout menuData={navigation} {...props}>
      <RouterOutlet routes={props.routes} />
    </Layout>
  )
}

export default HorizontalLayout
